import api from './api';
import { AdminUserSummary, AdminUserUpdateRequest, StatisticsResponse, GlobalStatisticsResponse, TokenTransaction } from '../types';

export const adminService = {
  async getGlobalStatistics(): Promise<GlobalStatisticsResponse> {
    const response = await api.get<GlobalStatisticsResponse>('/admin/statistics');
    return response.data;
  },

  async listUsers(): Promise<AdminUserSummary[]> {
    const response = await api.get<AdminUserSummary[]>('/admin/users');
    return response.data;
  },

  async getUserStatistics(username: string): Promise<StatisticsResponse> {
    const response = await api.get<StatisticsResponse>(`/admin/users/${encodeURIComponent(username)}/statistics`);
    return response.data;
  },

  async updateUser(username: string, data: AdminUserUpdateRequest): Promise<AdminUserSummary> {
    const response = await api.patch<AdminUserSummary>(`/admin/users/${encodeURIComponent(username)}`, data);
    return response.data;
  },

  async getUserTokenHistory(username: string, limit: number = 50): Promise<TokenTransaction[]> {
    const response = await api.get<TokenTransaction[]>(`/admin/users/${encodeURIComponent(username)}/token-history`, {
      params: { limit },
    });
    return response.data;
  },
};


